import { $authHost } from ".."

export const addDeliveryBySupplyBillAPI = async (delivery) => {
    const {data} = await $authHost.post(`api/deliveries/by_supply_bill/${delivery.supplyBillId}`, delivery)
    return data
}

export const editDeliveryByIdAPI = async (delivery) => {
    const {data} = await $authHost.post(`api/deliveries/${delivery.id}`, delivery)
    return data
}